import { LenderMap, LenderName, Pricing } from '@nemuru-eng/js-api-client';

export const getLendersFromPricing = (pricing: Pricing): LenderName[] => {
  const lenders: LenderName[] = [];
  pricing.ranges.forEach((range) => {
    range.lenderEarningsFees?.forEach((lenderEarningFee) => {
      const lenderName = LenderMap.fromLenderId(lenderEarningFee.lenderId);
      if (lenderName && !lenders.includes(lenderName)) {
        lenders.push(lenderName);
      }
    });
  });
  return lenders;
};
